import jStat from 'jstat';

import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { round3 } from 'utilities/math';
import { change, formValueSelector } from 'redux-form';

import CutoffsFieldsComponent from './Component';

const normalizeAlpha = alpha => {
  if (alpha < 0.001) {
    return 0.001;
  }

  if (alpha > 0.999) {
    return 0.999;
  }

  return round3(alpha);
};

class CutoffsFieldsContainer extends React.Component {
  constructor (props) {
    super(props);

    this.handleLeftCutoffChange = (_, cutoffValue) => {
      const { form, mean, stdev } = this.props;

      let alpha = jStat.normal.cdf(+cutoffValue, mean, stdev);

      alpha = this.props.tailType === 'both' ? alpha * 2 : alpha;

      this.props.change(form, 'alpha', normalizeAlpha(alpha));
    };

    this.handleRightCutoffChange = (_, cutoffValue) => {
      const { form, mean, stdev } = this.props;

      let alpha = 1 - jStat.normal.cdf(+cutoffValue, mean, stdev);

      alpha = this.props.tailType === 'both' ? alpha * 2 : alpha;

      this.props.change(form, 'alpha', normalizeAlpha(alpha));
    };
  }

  get isLeftCutoffFieldVisible () {
    return this.props.tailType === 'left' ||
           this.props.tailType === 'both';
  }

  get isRightCutoffFieldVisible () {
    return this.props.tailType === 'right' ||
           this.props.tailType === 'both';
  }

  render () {
    return (
      <CutoffsFieldsComponent
        onLeftCutoffChange={this.handleLeftCutoffChange}
        onRightCutoffChange={this.handleRightCutoffChange}

        isLeftCutoffFieldVisible={this.isLeftCutoffFieldVisible}
        isRightCutoffFieldVisible={this.isRightCutoffFieldVisible}
      />
    );
  }
}

CutoffsFieldsContainer.propTypes = {
  change: PropTypes.func.isRequired,
  form: PropTypes.string.isRequired,

  mean: PropTypes.number.isRequired,
  stdev: PropTypes.number.isRequired,

  tailType: PropTypes.string.isRequired
};

const mapStateToProps = (state, props) => {
  const selector = formValueSelector(props.form);
  return { tailType: selector(state, 'tailType') };
};

const mapDispatchToProps = {
  change
};

export default connect(mapStateToProps, mapDispatchToProps)(
  CutoffsFieldsContainer
);
